const texts = {
  TAGLINE: "En control de tus finanzas",
  USER_PLACEHOLDER: "Email",
  NAME_PLACEHOLDER: "Nombre completo",
  EMAIL_PLACEHOLDER: "Email",
  PASSWORD_PLACEHOLDER: "Contraseña",
  ENTER: "Ingresar",
  ACCEPT: "Aceptar",
  CANCEL: "Cancelar",
  DELETE: "Eliminar",
  CREATE_ACCOUNT: "Crear cuenta",
  FORGOT_PASSWORD: "Olvidé mi contraseña",
  DISCLAIMER:
    "En esta primera versión, CASA no utiliza contraseña para sus usuarios. No te preocupes, nadie podrá acceder a tu información sin que le des permiso.",
  API_ERROR:
    "Ocurrió un error inesperado, por favor inéntalo denuevo más tarde.",
  ACTIVE_CARDS: "Cartas activas",
  SOLD_CARDS: "Cartas vendidas",
  DEACTIVATE: "Desactivar",
  ACTIVATE: "Activar",
  SOLD_ON: "Vendida",
  ADD_CARD: "Añadir carta",
  CHANGE_VERSION: "Cambiar versión",
  CHOOSE_VERSION: "Elegir",
  CURRENT_VERSION: "Actual",
  VERSION_CHANGED: "Versión actualizada.",
  SHIFT_BACK: "Correr desde acá un lugar atrás",
  POCKET_VISIBLE: "Visible",
  POCKET_ORDER_HINT: "La primera carta de la lista es la que se ve en el bolsillo.",
  STACK_UP: "Subir en la pila",
  STACK_DOWN: "Bajar en la pila",
  SHIFT_AHEAD: "Correr desde acá un lugar adelante",
  IMPORT_COLLECTION: "Importar colección",
  IMPORTING_COLLECTION: "Importando el archivo…",
  EXPORT_CSV: "Exportar en CSV",
  IMPORT_DONE_CARDS: " carta(s) importadas",
  IMPORT_SKIPPED: " bolsillo(s) vacío(s)",
  IMPORT_ERRORS: " fila(s) con error",
  CARD_NAME: "Escribe el nombre de la carta",
  SEARCH: "Buscar",
  SELECT_VERSION: "Selecciona la versión de tu carta.",
  CONDITION: "Estado",
  LANGUAGE: "Idioma",
  QUANTITY: "Cantidad",
  ADDING: "Añadiendo",
  ADD: "Añadir",
  HOME: "Home",
  BACK: "Volver",
  NO_STOCK_NOW: "Sin stock ahora",
  MY_COLLECTION: "Colección",
  MY_SALES: "Ventas",
  MY_ACCOUNT: "Cuenta",
  BUY: "Comprar",
  LOGIN: "Ingresar",
  LOGOUT: "Salir",
  MENU: "Menú",
  CREATE_USERNAME: "Nombre de usuario",
  CREATE_NAME: "Nombre completo",
  CREATE_EMAIL: "Email",
  CREATE_PASSWORD: "Contraseña",
  CONFIRM_DELETE_CARD_START: "¿Eliminar ",
  CONFIRM_DELETE_CARD_END: "?",
  AVAILABLE: "Disponibles: ",
  I_WANT_IT: "Lo quiero",
  STORE_SEARCH: "Busca en la tienda",
  SELL_CARDS: "Vender",
  SELECT: "Seleccionar",
  CK_REFERENCE: "CK",
  CK_BUYLIST: "compra",
  CK_NONE: "sin referencia",
  CARDS_IN_SALE: "Cartas en la venta",
  SELL_TITLE: "Venta en mostrador",
  SELL_HINT:
    "Buscá en el stock y agregá las cartas a la venta. Al cobrar, el monto se acredita a los dueños de cada carta.",
  SELL_EMPTY: "No hay ninguna venta en curso.",
  SELL_NO_RESULTS: "No se encontró ninguna carta disponible con ese nombre.",
  CANCEL_SALE: "Cancelar venta",
  CONFIRM_CANCEL_SALE:
    "¿Cancelar la venta? Las cartas quedan para devolver a su lugar.",
  CARDS_AVAILABLE_IN_STORE: "Cartas disponibles en la tienda",
  UPDATE_DETAILS: "Actualiza tus datos",
  UPDATE_PASSWORD: "Actualiza tu contraseña",
  UPDATED_DETAILS: "Tus datos han sido actualizados.",
  MY_DETAILS: "Mis datos",
  PHONE_PLACEHOLDER: "Celular",
  NOT_SET: "—",
  EMAIL_IS_LOGIN: "Tu email es tu usuario para ingresar.",
  CHANGE_PASSWORD: "Cambiar contraseña",
  PASSWORD_CHANGED: "Contraseña actualizada.",
  CONFIRM_PASSWORD: "Repetir nueva contraseña",
  PASSWORD_MISMATCH: "Las contraseñas no coinciden.",
  PASSWORD_TOO_SHORT: "La contraseña debe tener al menos 8 caracteres.",
  CURRENT_PASSWORD: "Contraseña actual",
  NEW_PASSWORD: "Nueva contraseña",
  PAY: "Pagar",
  PAY_TITLE: "Pagar al cliente",
  PAY_OWED: "Dinero pendiente de cobro",
  PAY_AMOUNT: "Monto a pagar (pesos)",
  PAY_ALL: "Pagar todo",
  PAY_OVER: "No podés pagar más de lo que se le debe.",
  PAY_REMAINING: "Quedará pendiente",
  PAY_DONE: "Pago registrado",
  STORAGE: "Contenedores",
  STORAGE_TITLE: "Contenedores",
  // The three lists of the container page: what is selling, what is being
  // brought in, and what is out of the shop's hands (retired or handed back).
  STORAGE_ACTIVE: "En la tienda",
  STORAGE_OFF_SALE_LIST: "Retirados de la venta",
  STORAGE_RETIRED_LIST: "Retirados por su dueño (esperando entrega)",
  STORAGE_INCOMING: "En camino a la tienda",
  STORAGE_AWAY: "Fuera de la tienda",
  ACTIONS: "Acciones",
  SAVE: "Guardar",
  NO_CONTAINERS: "No hay ningún contenedor todavía.",
  STORAGE_SEARCH: "Buscar por contenedor o dueño",
  STORAGE_NO_MATCHES: "Ningún contenedor coincide con la búsqueda.",
  COL_CONTAINER: "Contenedor",
  COL_OWNER: "Dueño",
  PER_PAGE: "Por página:",
  BINDER: "Carpeta",
  SORTED_BOX: "Caja ordenada",
  UNSORTED_BOX: "Caja sin ordenar",
  EDITION_BOX: "Caja de edición",
  // The set checklist: an edition box is the set printed out, with a quantity
  // beside every card.
  EDITION_SET: "Edición",
  EDITION_SET_HINT:
    "La edición no se puede cambiar después: la caja ES esa edición.",
  EDITION_SEARCH: "Buscar por nombre o número",
  EDITION_NO_MATCHES: "Ninguna carta coincide con la búsqueda.",
  EDITION_EMPTY_SET: "Esta edición no tiene cartas en papel.",
  EDITION_ONLY_HELD: "Mostrar sólo las que tengo",
  EDITION_ORDER: "Orden",
  EDITION_ORDER_COLLECTOR: "Número de coleccionista",
  EDITION_ORDER_COLOR_MANA: "Color y mana value",
  EDITION_PROGRESS_1: " de ",
  EDITION_PROGRESS_2: " casilleros con al menos una copia",
  EDITION_COL_NUMBER: "N°",
  EDITION_COL_CARD: "Carta",
  EDITION_COL_FINISH: "Terminación",
  EDITION_COL_QUANTITY: "Cantidad",
  EDITION_BAGGED_1: "+",
  EDITION_BAGGED_2: " apartada(s) para un pedido",
  EDITION_IMPORT_REPORT_TITLE: "Importación terminada",
  EDITION_IMPORT_REPORT_INTRO:
    ". Estas cartas no se pudieron importar:",
  EDITION_IMPORT_REPORT_CLOSE: "Entendido",
  EDITION_IMPORT_LINE: "Fila ",
  EDITION_IMPORT_REASONS: {
    not_in_edition: "No pertenece a la edición de esta caja.",
    quantity_too_high:
      "Superaría el máximo de copias por carta de una caja de edición.",
    no_name: "La fila no tiene nombre de carta.",
  },
  EDITION_SAVE_FAILED: "No se pudo guardar la cantidad.",
  EDITION_VARIATIONS: "Variaciones de estado e idioma",
  EDITION_VARIATIONS_HINT:
    "Copias en otro estado o idioma, además de las NM en inglés de la fila.",
  EDITION_VARIATIONS_TOTAL: "Total con variaciones: ",
  EDITION_ADD_VARIATION: "Agregar variación",
  EDITION_VARIATION_IS_DEFAULT: "Elegí un estado o idioma distinto de NM en inglés.",
  EDITION_LOCKED:
    "Las cartas de una caja de edición se cargan con la cantidad de cada una.",
  NEW_STORAGE: "Nuevo contenedor",
  EDIT_STORAGE: "Editar contenedor",
  STORAGE_NAME: "Nombre",
  STORAGE_TYPE: "Tipo",
  STORAGE_OWNER: "Dueño",
  STORAGE_OWNER_SHOP: "La tienda",
  STORAGE_OWNER_HINT:
    "Cambiar el dueño mueve las cartas del contenedor a su colección.",
  // Whether shoppers can leaf through the container in the storefront. About
  // the CONTAINER, never about whether its cards sell.
  STORAGE_BROWSABLE: "Explorable en la tienda",
  STORAGE_BROWSABLE_HINT:
    "Si está apagado, el contenedor no aparece para explorar en la tienda. Sus cartas se siguen vendiendo y apareciendo en las búsquedas.",
  STORAGE_NOT_BROWSABLE: "No explorable",
  SHOP: "Tienda",
  IN_SHOP: "En la tienda",
  WITH_CUSTOMER: "Con el cliente",
  // Lifecycle states of a customer's container, and the shop's moves between
  // them. See services/storageState.js in the API.
  STATE_FOR_SALE: "En venta",
  STATE_RETIRED: "Retirado por el dueño",
  STATE_RELEASED: "Entregado",
  STATE_RETURNING: "Lo está trayendo",
  DO_RELEASE: "Entregar al dueño",
  DO_RETURN_TO_OWNER: "Devolver al dueño",
  DO_ACCEPT: "Recibir y poner en venta",
  DO_CANCEL_RETIRE: "Cancelar retiro",
  DO_OFF_SALE: "Sacar de venta",
  DO_BACK_ON_SALE: "Volver a poner en venta",
  STORAGE_RETURNED: "Contenedor devuelto al dueño.",
  HELD_BACK: "Cartas que quedan en la tienda (ya apartadas para un pedido):",
  NOTHING_HELD_BACK: "No queda ninguna carta apartada.",
  CREATE: "Crear",
  RENAME: "Renombrar",
  EDIT: "Editar",
  CARDS: "cartas",
  EMPTY_POCKET: "vacío",
  PAGE: "Página",
  PREVIOUS: "Anterior",
  NEXT: "Siguiente",
  BACK_TO_STORAGE: "Volver a contenedores",
  POSITION_IN_BOX: "Posición",
  OF: "de",
  IN_POCKET: "bolsillo",
  DEPTH: "profundidad",
  CONFIRM_DELETE_STORAGE: "¿Eliminar este contenedor?",
  CONFIRM_DELETE_STORAGE_CARDS_1: "Este contenedor tiene ",
  CONFIRM_DELETE_STORAGE_CARDS_2:
    " carta(s) adentro. Al eliminarlo también se eliminan esas cartas. ¿Continuar?",
  ORDERS: "Pedidos",
  PRICING: "Precios",
  USERS: "Usuarios",
  USERS_TITLE: "Cuentas y roles",
  COL_ACCOUNT: "Cuenta",
  COL_ROLE: "Rol",
  USERS_HINT:
    "Las cuentas se crean desde la tienda; aquí solo se asigna el rol. Empleado vende y maneja el stock; dueño además cobra, paga y define precios.",
  ROLE_customer: "Cliente",
  ROLE_staff: "Empleado",
  ROLE_owner: "Dueño",
  ROLE_YOU: "tú",
  SAVE_ROLE: "Guardar",
  USERS_ADMINS: "Administradores",
  USERS_CLIENTS: "Clientes",
  USERS_SEARCH: "Buscar por nombre o email",
  COL_PHONE: "Celular",
  COL_CREDIT: "Saldos",
  SALE_MONEY_SHORT: "En tienda:",
  STORE_CREDIT_SHORT: "Store credit:",
  USERS_EMPTY: "No hay cuentas en esta lista.",
  USERS_NONE_MATCH: "Ninguna cuenta coincide con la búsqueda.",
  ROWS_PER_PAGE: "Por página:",
  EDIT_USER: "Editar usuario",
  ADJUST_CREDIT: "Ajustar crédito",
  FULL_NAME: "Nombre",
  PHONE: "Celular",
  EMAIL_READONLY: "Email (no editable)",
  CURRENT_CREDIT: "Crédito actual",
  CURRENT_STORE_CREDIT: "Store credit actual",
  CREDIT_ADD: "Sumar",
  CREDIT_SUBTRACT: "Restar",
  CREDIT_AMOUNT: "Monto en pesos",
  CREDIT_NOTE: "Nota (opcional)",
  CREDIT_NEW_TOTAL: "Quedaría",
  CREDIT_ADJUSTED_OK: "Crédito ajustado.",
  USER_UPDATED_OK: "Datos actualizados.",
  VIEW_HISTORY: "Ver historial",
  HISTORY_TITLE: "Historial",
  HISTORY_EMPTY: "Este usuario no tiene movimientos todavía.",
  HIST_PURCHASE: "Compra",
  HIST_SALE: "Venta",
  HIST_CREDIT: "Crédito",
  HIST_PAYOUT: "Pago",
  HIST_CREDIT_USED: "Usado como crédito",
  HIST_CASH: "efectivo",
  HIST_CREDIT_PART: "crédito",
  HIST_MORE: "más",
  ROLE_SAVED_OK: "Rol actualizado.",
  EXCHANGE_TITLE: "Tipo de cambio",
  EXCHANGE_HINT:
    "Los precios en pesos se calculan multiplicando el precio en dólares por este valor.",
  EXCHANGE_RATE_LABEL: "Pesos por dólar",
  EXCHANGE_NOT_SET: "Sin tipo de cambio configurado: se muestran solo dólares.",
  SAVE_EXCHANGE: "Guardar",
  EXCHANGE_SAVED: "Tipo de cambio actualizado.",
  MULTIPLIERS_TITLE: "Multiplicadores por estado",
  MULTIPLIERS_HINT:
    "CardKingdom publica un solo precio por carta, que es el de NM. El resto de los estados se calculan multiplicando ese precio.",
  MULT_SELL: "Venta",
  MULT_BUY: "Compra",
  SAVE_MULTIPLIERS: "Guardar y recalcular",
  PRICE_SEARCH_HINT:
    "Un precio fijado a mano no se toca en la importación diaria. Al volver a CK sigue al mercado de nuevo.",
  COL_SELL: "Venta",
  COL_BUY: "Compra",
  PRICES_UPDATED: "Precios actualizados.",
  FIXED_TITLE: "Precios fijos",
  ADD_FIXED_PRICE: "Fijar un precio",
  FIX_PRICE: "Fijar",
  RESET_TO_CK: "Volver a CK",
  RESET_DONE: "El precio vuelve a seguir al mercado.",
  NO_FIXED_PRICES: "No hay precios fijos; todo sigue al mercado.",
  FIXED_SET_PREFIX: "Precio fijado en ",
  FIXED_SET_SUFFIX: " carta(s) en stock.",
  FIXED_SET_NO_STOCK:
    "Precio fijado. No hay stock ahora; se aplicará cuando llegue.",
  FIXED_NO_STOCK_YET: "Sin stock — se aplicará cuando llegue",
  ORDERS_TITLE: "Pedidos de clientes",
  MATCHES_TITLE: "Cartas para apartar",
  MATCHES_HINT:
    "Estas cartas están en stock y alguien las tiene en su lista de deseados. Apártalas en la bolsa del cliente.",
  NO_MATCHES: "No hay cartas para apartar.",
  PREPARE_TITLE: "Pedidos para preparar",
  PREPARE_HINT:
    "Pedidos que los clientes confirmaron desde su carrito. Buscá cada carta y apartala; cuando estén todas, el pedido queda listo para retirar.",
  NO_PREPARE: "No hay pedidos para preparar.",
  SET_ASIDE: "Apartar",
  WHERE_IS_IT: "Dónde está",
  NO_LOCATION: "Sin ubicación registrada",
  PICK_FROM: "Tomar de",
  REFILE_TITLE: "Devolver a su lugar",
  REFILE_HINT: "Estas cartas salieron de la bolsa. Vuelve a guardarlas aquí:",
  REFILE_DONE: "Listo",
  UNPRICED_TITLE: "Cartas sin precio",
  UNPRICED_HINT:
    "Estas cartas están en stock pero no tienen precio, así que los clientes no las ven. Ponéles precio:",
  SET_PRICE: "Establecer precio",
  PRICE_SET: "Precio establecido.",
  REVERT_TO_CK: "Volver al precio de CardKingdom cuando esté disponible",
  REVERT_ON_HINT:
    "Cuando CardKingdom tenga un precio para esta carta, se va a usar ese en lugar de este.",
  REVERT_OFF_HINT:
    "Este precio queda fijo hasta que lo cambies a mano, aunque CardKingdom la liste después.",
  IN_STOCK: "en stock",
  DISMISS_MATCH: "Descartar",
  MATCH_PURCHASE: "Compra",
  MATCH_WITHDRAWAL: "Es del cliente",
  MATCH_WITHDRAWAL_HINT: "Se la lleva sin pagar",
  MATCH_CONFIRM_FIRST: "Confirmá con el cliente antes de apartar.",
  CONFIRM_DISMISS_MATCH:
    "El cliente no la quiere: se quitará de sus deseados y no se volverá a ofrecer. ¿Descartar?",
  WANTS: "Quiere",
  ANY_VERSION_OK: "cualquiera de estas versiones sirve",
  ALREADY_IN_BAG: "ya en bolsa",
  PICKUP_TITLE: "Bolsas para retirar",
  ORDER_STATUS_pending: "Reservado",
  ORDER_STATUS_completed: "Entregado",
  ORDER_STATUS_cancelled: "Cancelado",
  ORDER_STATUS_expired: "Vencido",
  ORDER_EXPIRES: "Vence el",
  ORDER_TOTAL: "Total",
  COMPLETE_ORDER: "Cobrar y entregar",
  CANCEL_ORDER: "Cancelar",
  REMOVE_LINE: "Quitar",
  CONFIRM_REMOVE_LINE:
    "¿Quitar esta carta del pedido? Vuelve a estar disponible y, si ya estaba apartada, hay que devolverla a su lugar.",
  EXTEND_ORDER: "Extender",
  CONFIRM_COMPLETE: "¿Cobrar y entregar este pedido? Se registrará la venta.",
  CHARGE_TITLE: "Cobrar pedido",
  PAY_CASH: "Efectivo",
  PAY_WITH_CREDIT: "Usar crédito",
  CREDIT_AVAILABLE: "Crédito disponible:",
  CREDIT_USED: "Crédito usado:",
  CASH_DUE: "Efectivo a cobrar:",
  CONFIRM_CANCEL_ORDER: "¿Cancelar este pedido? Las cartas volverán a estar disponibles.",
  NO_ORDERS: "No hay pedidos.",
  SHOW_ALL: "Ver todos",
  SHOW_PENDING: "Ver solo reservados",
  VARIANT_nonfoil: "Normal",
  VARIANT_foil: "Foil",
  VARIANT_etched: "Etched",

  // Container editing — same vocabulary as the customer platform.
  CONTAINER_EMPTY: "Este contenedor está vacío.",
  STORAGE_LOCKED:
    "Este contenedor está en manos de su dueño; la tienda no puede modificarlo.",
  STORAGE_ARRANGE_ONLY:
    "Contenedor de un cliente: podés reacomodarlo y agregarle cartas del cliente, pero no sacarlas.",
  STANDBY_TITLE: "En espera",
  STANDBY_HINT:
    "Arrastrá cartas acá para sacarlas de un bolsillo, y de acá a otro bolsillo.",
  STANDBY_EMPTY: "Sin cartas en espera.",
  POCKET: "bolsillo",
  POCKET_STACK: "Cartas en este bolsillo",
  POCKET_EXPAND_HINT:
    "Este bolsillo tiene varias cartas. Mandá una a la zona de espera para moverla.",
  TO_STANDBY: "A espera",
  DUPLICATE_COPY: "Duplicar (tengo otra igual)",
  DUPLICATE_FAILED: "No se pudo duplicar la carta:",
  ZOOM_CARD: "Ampliar carta",
  REMOVE_FAILED: "No se pudo sacar la carta:",
  DRAG_TO_REORDER: "Arrastrá para reordenar",
  UNSORTED_HINT:
    "Una caja sin ordenar no guarda posiciones; se lista alfabéticamente.",
  STANDBY_DISCARD_TITLE: "Quedan cartas en espera",
  STANDBY_DISCARD_1: "Si salís ahora se van a eliminar ",
  STANDBY_DISCARD_2:
    " carta(s) que dejaste en espera. Una carta no puede quedar sin contenedor.",
  STANDBY_KEEP_EDITING: "Seguir editando",
  STANDBY_DISCARD_CONFIRM: "Eliminar y salir",
  ADDED_TO_CONTAINER: "añadida(s) a",
  ADD_PAGE: "Añadir página",
  PREV_PAGES: "Páginas anteriores",
  NEXT_PAGES: "Páginas siguientes",
  GO_TO_PAGE: "Ir a página",
  REMOVE_FROM_CONTAINER: "Sacar",
  FILTER_BY_SET: "Filtrar por edición (nombre o código)",
  FILTER_BY_SET_SHORT: "Edición",
  VERSIONS: "versiones",
  NO_VERSIONS: "Ninguna versión coincide con el filtro.",
  LOADING_VERSIONS: "Cargando versiones...",
  ONLY_FINISH: "Solo existe en",
  CLOSE: "Cerrar",
  WISHLIST_PLACEHOLDER: "Buscá una carta",
  AUTOCOMPLETE_HINT: "Escribí al menos dos letras.",
  AUTOCOMPLETE_NONE: "No hay cartas con ese nombre.",
  SELL_NO_LOCATION: "Sin ubicación registrada",
};

module.exports = texts;
